import { useTranslation } from "react-i18next";
import { useTheme } from "../theme/ThemeProvider";
import { THEMES } from "../theme/themes";

/** Topbar button: jumps to the theme paired with the current one (light <-> dark). */
export function ThemeToggle() {
  const { t } = useTranslation();
  const { theme, toggleDarkLight } = useTheme();
  const next = THEMES[THEMES[theme].pair];
  // The default value also carries the theme name (not just "{{theme}}") so the
  // label reads correctly even before the locale bundle has loaded.
  const label = next.dark
    ? t("appearance.toggle.toDark", `Switch to the dark theme (${next.name})`, { theme: next.name })
    : t("appearance.toggle.toLight", `Switch to the light theme (${next.name})`, { theme: next.name });
  return (
    <button type="button" className="icon-btn" aria-label={label} title={label} onClick={() => void toggleDarkLight()}>
      {next.dark ? (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
          <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
        </svg>
      ) : (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
          <circle cx="12" cy="12" r="4" /><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
        </svg>
      )}
    </button>
  );
}
